import React, { useCallback, useEffect, useState } from 'react'
import SearchAndSelect from '../../../../components/generic/search/SearchAndSelect'
import { executeIntent } from '../../../utils/IntentExecutor';
import IntentType from '../../../../intentexecutor/utils/IntentType';
import { useGetOrgIdentifier } from '../../../generic/hooks/useGetOrgIdentifier';
import { getContext } from '../../../../intentexecutor/contextcreator/ContextCreator';
import { isEqual } from 'lodash';

const SelectTypeOFServices = ({typesOfServicesSelected, setTypesOfServicesSelected, readOnly, showLabel = true, className}) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [optionsList, setOptionsList] = useState([]);

  const style = {
    color: '#e32',
    content: ' *',
    display: 'inline',
  };

  const onSelectedServiceChanged = useCallback(
    (selectedServices) => {
      if (!isEqual(selectedServices, typesOfServicesSelected)) {
        setTypesOfServicesSelected([...selectedServices]);
      }
    },
    [setTypesOfServicesSelected, typesOfServicesSelected]
  );

  useEffect(() => {
    const fetchServiceList = async () => {
      const payload = {
        organizationIdentifier: organizationIdentifier,
      };
      const response = await executeIntent(IntentType.GET_ORGANIZATION_SERVICES, payload, getContext());
      const result = response.map(service => (
        {
          label: `${service.title}`,
          value: JSON.stringify(service)
        }
      ))
      setOptionsList(result);
    }
    fetchServiceList();
  }, [organizationIdentifier])

  return (
    <div className={className}>
      {showLabel && (
        <div className="section-two-header mb-2">
          <span className="required-mark-label" style={style}>
            Services
          </span>
        </div>
      )}
      <div>
        <SearchAndSelect
          mode="multiple"
          selectedValues={typesOfServicesSelected}
          placeholder="Click here to select services"
          setValue={onSelectedServiceChanged}
          style={{
            width: "100%",
          }}
          options={optionsList}
          selectOptionType="Simple"
          noDebounceSearch={true}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}

export default SelectTypeOFServices;